export const INSTATUS_KEYS = {
  all: () => ["instatus"] as const,
  summary: () => [...INSTATUS_KEYS.all(), "summary"] as const,
};
